<template>
  <div >
    <v-layout 
      style="position:absolute;right:0rem;top:0;z-index:10000">
        <v-btn 
          fab small color="white" 
          v-on:click="fitContent()"
        >
          <v-icon dark>zoom_out_map</v-icon>
        </v-btn>
        <v-btn 
          fab small color="white" 
        >
          <v-icon dark>not_listed_location</v-icon>
        </v-btn>
    </v-layout>
    <div id="mapid" :style="'height: '+((height)?height:'500px')+';width: 100%;z-index:0'"></div>
  </div>
</template>

<script>
import {antPath} from 'leaflet-ant-path';
import L from "leaflet/dist/leaflet"
import 'leaflet/dist/leaflet.css'
import "leaflet-draw/dist/leaflet.draw.css"
import "leaflet-draw"

export default {
  name: 'MapView',
  props: {
    perimeters: Array,
    markers: Array,
    // [{
    //    id
    //    coordinates: { latitude,longitude }
    //    htmlContentTooltip,
    //    fitZoom
    // }],
    paths: Array,
    // [{
    //    id
    //    markers:[{
    //      id
    //      coordinates: { latitude,longitude }
    //      info: { title, content }
    //    }]
    // }]
    height: String

  },
  data(){
    return{
      map: null,
      mapMarkers: [],
      markerLayer: null,
      // [{
      //    id,
      //    leafletMarker,
      //    leafletPanel,
      //    fitZoom
      // }],
      mapPaths:[],
      // [{
      //    id,
      //    leafletPath
      // }],
      colors: [
        '#f67019',
        '#f53794',
        '#537bc4',
        '#acc236',
        '#166a8f',
        '#00a950',
        '#58595b',
        '#8549ba',
        '#4dc9f6'
      ],
      areas: [],
    }
  },

  mounted(){
    this.map = L.map("mapid", {
        center: [0, 0],
        zoom: 2,
    });
    L.tileLayer("http://{s}.tile.osm.org/{z}/{x}/{y}.png", {}).addTo(this.map);
    
    // FeatureGroup is to store editable layers
    this.markerLayer = new L.FeatureGroup()
    this.map.addLayer(this.markerLayer)
    this.drawnItems = new L.FeatureGroup()
    this.map.addLayer(this.drawnItems)
    var drawControl = new L.Control.Draw({
      draw: {
        toolbar: {
          buttons: {
            polygon: 'Draw a polygon'
          }
        },
        polyline: false,
        polygon: true,
        circle: false,
        rectangle: false,
        circlemarker: false,
        marker: false
      }/*,
      edit: {
          featureGroup: this.drawnItems,
          remove: false
      }*/
    });
    this.map.addControl(drawControl);
    this.map.on(L.Draw.Event.CREATED, (e) => {
      var type = e.layerType;
      var layer = e.layer;
      layer.options.color = "green"
      this.map.removeLayer(this.drawnItems)
      this.drawnItems = new L.FeatureGroup()
      this.drawnItems.addTo(this.map)
      this.drawnItems.addLayer(layer);
      // console.log("Polygon drawed", e);
      if (type === 'polygon') {
        // console.log(JSON.stringify(layer._latlngs[0]));
        this.$emit("created", layer._latlngs[0]);
      }
    });

    /*
    this.map.on(L.Draw.Event.EDITED, (e) => {
        var layers = e.layers;
        var countOfEditedLayers = 0;
        layers.eachLayer(function (layers) {
            countOfEditedLayers++;
        });
        console.log("Edited " + countOfEditedLayers + " layers");
        this.$emit("edited", layers._latlngs[0]);
    });

    this.map.on(L.Draw.Event.DELETED, (e) => {
        var layers = e.layers;
        console.log("Deleted ", layers);
        this.$emit("deleted", layers._layers);
    });
    */

    this.map.on('click', (e) => {
      this.$emit("clickMap",{latitude:e.latlng.lat, longitude:e.latlng.lng});
    });
  },

  watch: {

    perimeters: {
      handler: function(fetchedPerimeters) {
        // window.console.log(this.mapMarkers)
        // window.console.log(this.map)
        this.map.removeLayer(this.drawnItems)
        this.drawnItems = new L.FeatureGroup()
        this.drawnItems.addTo(this.map)
        if (fetchedPerimeters.length !== 0) {
          fetchedPerimeters.forEach(fetchedPerimeter => {
            if (fetchedPerimeter.length !== 0){
              let currentPerimeter = JSON.parse(fetchedPerimeter[0].perimeter)
              L.polygon(currentPerimeter).addTo(this.drawnItems)
            }
          })
        }
      }
    
    },

    paths: {
      deep: true,
      handler: function (newPaths){
        // ** Remove all paths from map **
        this.mapPaths.forEach( 
          mapPath => {
            if(mapPath.leafletPath)
                mapPath.leafletPath.remove();
            if(mapPath.leafletMarkers)
              mapPath.leafletMarkers.forEach( m => m.removeFrom(this.map));
          }
        );
        this.mapPaths.splice(0);
        newPaths.forEach(
          (newPath) => {
            
            let path;
            if(newPath.markers.length>1){
              path = antPath(newPath.markers.map(marker => [marker.coordinates.latitude, marker.coordinates.longitude]), {
                "delay": 166,
                "dashArray": [
                  10,
                  20
                ],
                "weight": 5,
                "color": this.colors[(this.mapPaths.length % this.colors.length + this.colors.length) % this.colors.length ] ,
                "pulseColor": "#FFFFFF",
                "paused": false,
                "reverse": false,
                "hardwareAccelerated": true
              });
              path.addTo(this.map);
            }

            let markers = newPath.markers.map( 
              m => {
                let leafletMarker = createMarker(m,this.colors[(this.mapPaths.length % this.colors.length + this.colors.length) % this.colors.length]);
                leafletMarker.addTo(this.map);
                return leafletMarker;
              });
            this.mapPaths.push({
              id: newPath.id,
              leafletPath: path,
              leafletMarkers: markers
            });
          }
        );
        if(this.mapPaths.length>=1){
          let group = new L.featureGroup(
            this.mapPaths.reduce(
              (allMarkers,path) => 
                allMarkers.concat(path.leafletMarkers)
            ,[])
          )
          this.map.fitBounds(group.getBounds());
        }
      }
    },

    markers(newMarkers){

      let newMapMarkers = [];
      // ** Remove old unexisting marker **
      this.mapMarkers.forEach( 
        mapMarker => {
          let foundMarker = newMarkers.find(newMarker => newMarker.id == mapMarker.id);
          if(!foundMarker)
          {
            mapMarker.leafletMarker.removeFrom(this.markerLayer);
          }else{
            newMapMarkers.push(mapMarker);
          }
        }
      );
      this.mapMarkers.splice(0);
      this.mapMarkers = newMapMarkers;

      newMarkers.map(
        (newMarker) => {
          let foundMarker = this.mapMarkers.find(mapMarker => mapMarker.id == newMarker.id);
          if(foundMarker){
            // ** Set new position with animation **
            let deltaLat = newMarker.coordinates.latitude - foundMarker.leafletMarker.getLatLng().lat;
            let deltaLng = newMarker.coordinates.longitude - foundMarker.leafletMarker.getLatLng().lng;
            if(deltaLat!=0&&deltaLng!=0)
            {
              let stepLat = deltaLat/100;
              let stepLng = deltaLng/100;
              moving(
                foundMarker.leafletMarker, 
                { 
                  latitude: foundMarker.leafletMarker.getLatLng().lat, 
                  longitude: foundMarker.leafletMarker.getLatLng().lng
                },
                newMarker.coordinates, 
                {
                  latitude: stepLat,
                  longitude:stepLng
                }, 
                0
              );
            }
          }else{
            let leafletMarker = createMarker(newMarker,this.colors[(this.mapMarkers.length % this.colors.length + this.colors.length) % this.colors.length]);
            leafletMarker.addTo(this.markerLayer);
            this.mapMarkers.push({
              id: newMarker.id,
              leafletMarker:leafletMarker,
              fitZoom: newMarker.fitZoom
            })

          }
        }
      );
      if(this.mapMarkers.filter(mm => mm.fitZoom!=false).length>=1){
        let group = new L.featureGroup(this.mapMarkers.map(mm => mm.leafletMarker));
        this.map.fitBounds(group.getBounds());
      }
    }
  },

  methods:{
    fitContent(){
      if(this.mapMarkers.length>=1){
        let group = new L.featureGroup(this.mapMarkers.map(mm => mm.leafletMarker));
        this.map.fitBounds(group.getBounds());
      }
      if(this.mapPaths.length>=1){
        let group = new L.featureGroup(
          this.mapPaths.reduce(
            (allMarkers,path) => 
              allMarkers.concat(path.leafletMarkers)
          ,[])
        )
        this.map.fitBounds(group.getBounds());
      }
    }
  }
}

function moving(marker, startCoordinates, stopCoordinates, step, recursiveIndex){
  if(recursiveIndex==100){
    marker.setLatLng(L.latLng(
      stopCoordinates.latitude, 
      stopCoordinates.longitude
    ));
    return;
  }
  
  startCoordinates.longitude += step.longitude;
  startCoordinates.latitude += step.latitude;
  marker.setLatLng(L.latLng(
    startCoordinates.latitude, 
    startCoordinates.longitude
  ));
  recursiveIndex+=1;
  setTimeout(()=>moving(marker, startCoordinates, stopCoordinates, step, recursiveIndex),20);
}

function tooltipGenerator(htmlTitle,htmlBody){
  return `
    <style>
    .card {
      box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
      transition: 0.3s;background-color:white;
      width: 100%;
      font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    }

    .card:hover {
      box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2);
    }

    .container {
    }
    </style>
    </head>
    <div class="card" style="width:300px;">
      <div class="container" style="height:30%:width:100%;padding:0rem">
        <div style="background-color:#29B6F6;padding:5px;color:#FAFAFA">
        ${htmlTitle}
        </div>
        <div style="height:70%:width:100%;padding:5px;background-color:white">
        ${htmlBody}
        </div>
      </div>
    </div>
    `
}


function createMarker(newMarker, color){

  let svg = `
    <svg xmlns="http://www.w3.org/2000/svg" height="100" width="100">

      <circle cx="50" cy="50" r="35" stroke="${color}" stroke-width="3" fill="${color}" class="blob" >
        <animate attributeType="SVG" attributeName="r" begin="0s" dur="1.5s" repeatCount="indefinite" from="5%" to="25%"/>
        <animate attributeType="CSS" attributeName="stroke-width" begin="0s"  dur="1.5s" repeatCount="indefinite" from="3%" to="0%" />
        <animate attributeType="CSS" attributeName="opacity" begin="0s"  dur="1.5s" repeatCount="indefinite" from="1" to="0"/>
      </circle>
    </svg>`;
  let iconUrl = encodeURI("data:image/svg+xml," + svg).replace(/#/g,'%23');
  
  // ** Add new marker to map **
  let icon = L.icon({
    iconUrl: iconUrl,//'./device.png',
    iconSize: [40, 40],
    iconAnchor: [20, 20],
    popupAnchor: [-20, -86]
  });
  let leafletMarker = L.marker(
    L.latLng(
      newMarker.coordinates.latitude, 
      newMarker.coordinates.longitude
    ),
    { icon: icon }
  );
  leafletMarker.bindPopup("<div style='padding:0;margin-top:-13.5px;margin-bottom:-14px;margin-left:-20px;margin-right:-21px'>"+tooltipGenerator(newMarker.htmlContentTooltip.title,newMarker.htmlContentTooltip.body)+"</div>", 
    {
        direction: 'right',
        permanent: false,
        sticky: true,
        offset: [20, 100],
        opacity: 0.75,
        backgroundColor: 'black'
    }
  );
  leafletMarker.bindTooltip("<div style='padding:0;margin:-13.5px;align-content: left !important;'>"+tooltipGenerator(newMarker.htmlContentTooltip.title,newMarker.htmlContentTooltip.body)+"</div>", 
    {
        direction: 'right',
        permanent: false,
        sticky: true,
        offset: [0, 0],
        opacity: 0.75,
        backgroundColor: 'black'
    }
  );
  return leafletMarker
}

</script>

<style >


</style>
